module.exports = __webpack_public_path__ + "img/djsm.5022b8d2.png";